import React, { Component } from "react";
import Hero from "../components/MainHero";
import Tickets from "../components/MainTickets";
import LargestJackpot from "../components/MainLargestJackpot";
import HowItWorks from "../components/MainHowItWorks";
import EventSelection from "./EventSelection";
import { AppContext } from "../utils/context";
import RemainingCardsEnvelopes from "../components/RemainingCardsEnvelopes";
import Countdown from '../components/Countdown';
import { Helmet } from "react-helmet";
import SocialShare from '../components/SocialShare';

class Home extends Component {
  render() {
    const { events, language, settings, event } = this.context;
    return (
      <div>
        <Helmet>
          {settings.scripts_home_page && <script>{settings.scripts_home_page}</script>}
        </Helmet>
        <SocialShare
          facebook={settings.facebook}
          twitter={settings.twitter}
          linkedIn={settings.linkedIn}
          whatsApp={settings.whatsApp} 
          pinterest={settings.pinterest} 
          reddit={settings.reddit}
          socialEmail={settings.socialEmail}
          title={settings.socialTitle ?  settings.socialTitle : settings.client_name.concat(" ", event.title ? event.title : "") }
          shareImage={settings.header_logo}
        />
        {event.id > 0 ? (
          <div>
            <Hero 
            event={event}
            language={language} 
            settings={settings} 
            />
            <Tickets />
            {event.game.id === 3 && +settings.web_show_cards_remaining_home_page === 1 && <RemainingCardsEnvelopes 
            event={event} 
            settings={settings} 
            language={language} 
            />}
            {+settings.web_countdown_enabled === 1 && <Countdown 
              date={Date.now() < new Date(event.start_at) ? event.start_at : event.end_at} 
              countdownLabel={
                event.countdown_title !== "" ? event.countdown_title : (
                  Date.now() < new Date(event.start_at) ? 'Sales Start In:' : (
                    Date.now() > new Date(event.end_at) ? 'Sales Closed' : 
                      'Sales End In:'
                    )
                  )
                } 
              />
            }
            {+settings.display_largest_jackpot === 1 && (<LargestJackpot event={event} language={language} />)}
            <HowItWorks 
            event={event} 
            settings={settings} 
            language={language} 
            />
          </div>
          ) : <EventSelection 
          events={events} 
          language={language} 
          />
        }
      </div>
    );
  }
}
Home.contextType = AppContext;

export default Home;
